module.exports = __webpack_public_path__ + "static/media/crustaceans.f550b3f2.svg";